<template>
  <div class="client-registration">

    <div class="registration-card">
      <!-- Compact Header -->
      <div class="card-header">
        <div class="header-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <div class="header-text">
          <h2 class="card-title">New Client</h2>
          <p class="card-subtitle">Fill details to register</p>
        </div>
      </div>

      <form @submit.prevent="createClient" class="registration-form">
        <!-- Compact Form Grid -->
        <div class="compact-grid">
          
          <!-- Row 1: Client Name & ID Number -->
          <div class="form-group">
            <label>
              <span class="label-text">Client Name</span>
              <span class="required-star">*</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">👤</span>
              <input 
                type="text" 
                v-model="form.client_name" 
                required 
                placeholder="Full name"
                class="fancy-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label>
              <span class="label-text">ID Number</span>
              <span class="required-star">*</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">🆔</span>
              <input 
                type="text" 
                v-model="form.idNumber" 
                required 
                placeholder="ID/Passport"
                class="fancy-input"
              />
            </div>
          </div>

          <!-- Row 2: DOB & Phone -->
          <div class="form-group">
            <label>
              <span class="label-text">Date of Birth</span>
              <span class="required-star">*</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">🎂</span>
              <input 
                type="date" 
                v-model="form.dateofbirth" 
                required 
                class="fancy-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label>
              <span class="label-text">Phone</span>
              <span class="required-star">*</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">📱</span>
              <input 
                type="text" 
                v-model="form.phone_number" 
                required 
                placeholder="+1 234 567 890"
                class="fancy-input"
              />
            </div>
          </div>

          <!-- Row 3: Email & Business Email -->
          <div class="form-group">
            <label>
              <span class="label-text">Email</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">✉️</span>
              <input 
                type="email" 
                v-model="form.email" 
                placeholder="personal@email.com"
                class="fancy-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label>
              <span class="label-text">Business Email</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">🏢</span>
              <input 
                type="email" 
                v-model="form.business_email" 
                placeholder="business@company.com"
                class="fancy-input"
              />
            </div>
          </div>

          <!-- Row 4: Address (Full Width) -->
          <div class="form-group full-width">
            <label>
              <span class="label-text">Address</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">📍</span>
              <input 
                type="text" 
                v-model="form.address" 
                placeholder="Street, city, country"
                class="fancy-input"
              />
            </div>
          </div>

          <!-- Row 5: Loan Limit & Bank -->
          <div class="form-group">
            <label>
              <span class="label-text">Loan Limit</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">💰</span>
              <input 
                type="number" 
                v-model="form.loan_limit" 
                min="0" 
                placeholder="0.00"
                class="fancy-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label>
              <span class="label-text">Bank</span>
            </label>
            <div class="input-wrapper">
              <span class="input-icon">🏦</span>
              <input 
                type="text" 
                v-model="form.bank" 
                placeholder="Bank name"
                class="fancy-input"
              />
            </div>
          </div>

        </div>

        <!-- Compact Actions -->
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" @click="$router.push('/loan/clients')" title="Go back">
            <span class="btn-icon">Go back</span>
          </button>
          <button type="submit" class="btn btn-primary" :disabled="loading">
            <span v-if="!loading" class="btn-icon">✓</span>
            <span v-if="loading" class="loading-spinner"></span>
            <span>{{ loading ? "Creating..." : "Create Client" }}</span>
          </button>
        </div>

        <!-- Compact Messages -->
        <transition name="fade">
          <div v-if="successMessage" class="message success">
            <span class="message-icon">✅</span>
            <span class="message-text">{{ successMessage }}</span>
            <button class="message-close" @click="successMessage = ''">×</button>
          </div>
        </transition>
        
        <transition name="fade">
          <div v-if="errorMessage" class="message error">
            <span class="message-icon">❌</span>
            <span class="message-text">{{ errorMessage }}</span>
            <button class="message-close" @click="errorMessage = ''">×</button>
          </div>
        </transition>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateClient",
  data() {
    return {
      loading: false,
      successMessage: "",
      errorMessage: "",
      form: {
        client_name: "",
        idNumber: "",
        dateofbirth: "",
        phone_number: "",
        email: "",
        business_email: "",
        address: "",
        loan_limit: 0,
        bank: "",
      },
    };
  },
  methods: {
async createClient() {
  this.loading = true;
  this.successMessage = "";
  this.errorMessage = "";

  try {
    const response = await axios.post(
      "https://api.roberms.com/raisetrack/new/loan/client",
      this.form
    );

    this.successMessage = response.data.message;

    this.resetForm();
setTimeout(() => {
  this.$router.push("/loan/clients");
}, 1500);

  } catch (error) {
    this.errorMessage =
      error.response.data.message || "Something went wrong";
  } finally {
    this.loading = false;
  }
},
    
    resetForm() {
      this.form = {
        client_name: "",
        idNumber: "",
        dateofbirth: "",
        phone_number: "",
        email: "",
        business_email: "",
        address: "",
        loan_limit: 0,
        bank: "",
      };
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.client-registration {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: linear-gradient(145deg, #1a1f2e 0%, #2d1f3a 100%);
  font-family: 'Inter', sans-serif;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.registration-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  width: 100%;
  max-width: 800px;
  margin: 20px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.4s ease-out;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Compact Header */
.card-header {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(145deg, #ffffff, #fafcff);
  border-bottom: 1px solid rgba(102, 126, 234, 0.15);
  flex-shrink: 0;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(145deg, #667eea, #764ba2);
  border-radius: 10px;
  margin-right: 12px;
  color: white;
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.25);
}

.header-text {
  flex: 1;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.card-subtitle {
  font-size: 12px;
  color: #718096;
  margin: 2px 0 0 0;
  font-weight: 400;
}

/* Compact Form */
.registration-form {
  padding: 20px 24px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* Hide scrollbar but keep functionality */
.registration-form::-webkit-scrollbar {
  width: 4px;
}

.registration-form::-webkit-scrollbar-track {
  background: transparent;
}

.registration-form::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.3);
  border-radius: 20px;
}

.registration-form::-webkit-scrollbar-thumb:hover {
  background: rgba(102, 126, 234, 0.5);
}

.compact-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.full-width {
  grid-column: span 2;
}

/* Compact Form Groups */
.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.required-star {
  color: #e53e3e;
  margin-left: 2px;
  font-size: 14px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 10px;
  font-size: 14px;
  color: #a0aec0;
  transition: color 0.2s ease;
  z-index: 1;
}

.fancy-input {
  width: 100%;
  padding: 8px 12px 8px 32px;
  font-size: 13px;
  border: 1.5px solid #edf2f7;
  border-radius: 10px;
  background: #f8fafc;
  transition: all 0.2s ease;
  outline: none;
  color: #2d3748;
  line-height: 1.4;
}

.fancy-input:hover {
  border-color: #cbd5e0;
  background: white;
}

.fancy-input:focus {
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.fancy-input:focus + .input-icon {
  color: #667eea;
}

.fancy-input::placeholder {
  color: #cbd5e0;
  font-size: 12px;
}

input[type="date"].fancy-input {
  padding-right: 8px;
  font-size: 12px;
}

/* Compact Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  flex-shrink: 0;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 6px;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.3px;
}

.btn-primary {
  background: linear-gradient(145deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  flex: 0.7;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: white;
  color: #4a5568;
  border: 1.5px solid #e2e8f0;
  padding: 10px 14px;
  flex: 0.3;
}

.btn-secondary:hover:not(:disabled) {
  background: #f7fafc;
  border-color: #cbd5e0;
  transform: translateY(-1px);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-icon {
  font-size: 16px;
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s linear infinite;
  margin-right: 4px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Compact Messages */
.message {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 10px;
  margin-top: 16px;
  animation: slideIn 0.3s ease;
  position: relative;
  font-size: 13px;
  flex-shrink: 0;
}

.message.success {
  background: #f0fff4;
  border: 1px solid #9ae6b4;
  color: #276749;
}

.message.error {
  background: #fff5f5;
  border: 1px solid #fc8181;
  color: #c53030;
}

.message-icon {
  margin-right: 10px;
  font-size: 16px;
}

.message-text {
  flex: 1;
  font-weight: 500;
}

.message-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: inherit;
  opacity: 0.5;
  padding: 0 4px;
  transition: opacity 0.2s ease;
  line-height: 1;
}

.message-close:hover {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Remove spinners from number input */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Compact mode adjustments */
@media (max-height: 700px) {
  .compact-grid {
    gap: 12px;
  }
  
  .form-group label {
    font-size: 11px;
    margin-bottom: 2px;
  }
  
  .fancy-input {
    padding: 6px 12px 6px 32px;
    font-size: 12px;
  }
  
  .card-header {
    padding: 12px 20px;
  }
}

/* Ensure it works on very small screens */
@media (max-width: 600px) {
  .compact-grid {
    grid-template-columns: 1fr;
  }
  
  .full-width {
    grid-column: span 1;
  }
  
  .registration-card {
    margin: 12px;
    max-height: calc(100vh - 24px);
  }
}
</style>